<button nz-button nz-tooltip nzTooltipTitle="Objekta informācija" nzType="info" (click)="openEntityInfoModal()">
    <span nz-icon nzType="info-circle" nzTheme="outline"></span>
</button>
